import { Component } from '@opten/compiler/metadata/component';
import { addClass } from '@opten/dom/add-class';

@Component({ className: 'js-map-interactive' })
export class MapInteractiveComponent {
	constructor(private element: HTMLSelectElement) {
		const links = Array.from(
			this.element.querySelectorAll('.js-map-interactive-link')
		)?.map((o) => ({
			id: o.getAttribute('data-id'),
			url: o.getAttribute('href'),
		}));
		const logos = this.element.querySelectorAll<SVGGElement>(
			'[id$="-Logo"]'
		);
		logos?.forEach((logo) => {
			const link = links?.find(
				(o) => logo.id.toLowerCase().indexOf(o.id) >= 0
			);
			if (link) {
				addClass(logo, 'map-interactive-logo');
				logo.addEventListener('click', (e) => {
					e.preventDefault();
					window.open(link.url);
				});
			}
		});
	}
}
